/**
 * Statement of Applicability applicability decisions (ISO/IEC 27001:2022 Cl. 6.1.3(d); Stage 6,
 * PolicyLense Workflow slide 10). The server stores 'Y' | 'N' | 'UNSET': 'UNSET' means no human
 * decision has been recorded and must never be shown (or treated) as applicable. User ruling:
 * absent is acceptable, fake is not.
 */
export const SOA_UNSET_CODE = "SOA_APPLICABILITY_UNSET";

/** 'Y' | 'N' | 'UNSET' — anything that is not an explicit Y/N is UNSET (never defaults to 'Y'). */
export function normalizeSoaApplicable(v) {
  const a = String(v ?? "").trim().toUpperCase();
  if (a === "Y") return "Y";
  if (a === "N") return "N";
  return "UNSET";
}

/** Annex display ids of the rows with no applicability decision. */
export function listUnsetSoaControls(rows) {
  return (Array.isArray(rows) ? rows : [])
    .filter((r) => r && normalizeSoaApplicable(r.applicable) === "UNSET")
    .map((r) => String(r.controlIdDisplay || r.controlId || "").trim())
    .filter(Boolean);
}

/**
 * Strip the machine code from a server message so the user reads plain English.
 * `SOA_APPLICABILITY_UNSET: set Applicable ...` -> `set Applicable ...` (first letter capitalised).
 * @returns {{ isSoaUnset: boolean, message: string }}
 */
export function plainSoaGateMessage(message) {
  const m = String(message ?? "");
  if (!m.startsWith(SOA_UNSET_CODE)) return { isSoaUnset: false, message: m };
  const rest = m.slice(SOA_UNSET_CODE.length).replace(/^\s*:\s*/, "").trim();
  return { isSoaUnset: true, message: rest ? rest.charAt(0).toUpperCase() + rest.slice(1) : m };
}
